import {IBannerSass} from "./types";
import {sassData} from "../editor/css";
import {sassBase, sassHorizontal, sassMain, sassInterstitialLandscape, sassVariables} from "../editor/sass";

export const defaultBannerSass: IBannerSass = {
    id: "default_child_sass",
    parentId: "default_master_sass",
    isMaster: false,
    name: "default child sass",
    files: {
        index: sassMain,
        base: sassBase,
        variables: sassVariables,
        horizontal: sassHorizontal,
        interstitialLandscape: sassInterstitialLandscape,

    },
    created: {},
    updated: {}
}

export const defaultMasterBannerSass: IBannerSass = {
    id: "default_master_sass",
    isMaster: true,
    name: "default master sass",
    files: {
        index: '@import "base"',
        base: sassData,
        variables: ''
    },
    created: {},
    updated: {}
}
